import React from 'react';
import styled from '@emotion/styled';
import { NoData } from '../NoData/NoData';

export const RoundedBottomBorder = styled.div`
    border: 1px solid ${(p) => p.theme.color.grayDark};
    background: ${(p) => p.theme.color.grayDark3};
    width: ${(p) => {
        if (p.fullWidth) {
            return '100%';
        } else if (p.chartWidth) {
            return `${p.chartWidth}px`;
        }
        return 'fit-content';
    }};
    border-radius: 0 0 4px 4px;
`;

export const VisibleCenter = styled.div`
    width: ${(p) => {
        const visibleCenterWidth = Math.min(p.chartWidth, p.viewportWidth);
        return `${visibleCenterWidth}px`;
    }};
`;

export const RoundedBottomBorderNoData = ({ chartWidth, message }) => {
    const viewportWidth = window.innerWidth;

    return (
        <RoundedBottomBorder chartWidth={chartWidth}>
            <VisibleCenter chartWidth={chartWidth} viewportWidth={viewportWidth}>
                <NoData name="no-data" message={message} />
            </VisibleCenter>
        </RoundedBottomBorder>
    );
};
